import isEmpty from '../isEmpty';

const isObject = value => {
  return typeof value === 'object' && value?.constructor === Object;
};

const removeEmptyValuesFromObject = (obj, recursive = true) => {
  return Object.entries(obj).reduce((result, [key, value]) => {
    const recurseChildObject = recursive && isObject(value);

    const updatedValue = recurseChildObject
      ? removeEmptyValuesFromObject(value)
      : value;

    if (isEmpty(updatedValue)) return result;
    return { ...result, [key]: updatedValue };
  }, {});
};

export default removeEmptyValuesFromObject;
